// Helper PURO del media plan (sin React): módulo propio para poder testearlo sin montar la
// pantalla de la propuesta, igual que `proposalSummary`.

/**
 * Identidad ESTABLE de una fila del acordeón, entre regeneraciones de la propuesta.
 *
 * El backend crea propuesta e items con PKs NUEVAS cada vez que la propuesta se regenera (responder
 * una duda, vincular, posponer). Por eso el acordeón NO puede usar `item.id` para nada que tenga que
 * sobrevivir a esa transición: ni para saber qué fila está abierta, ni como `key` de React. Con el
 * id, el render siguiente a una regeneración no encontraba ninguna fila abierta — el acordeón se
 * cerraba entero por un frame, el documento se acortaba cientos de píxeles, el navegador clampeaba
 * el scroll al nuevo alto, y para cuando la fila se reabría el usuario ya estaba arriba de todo. Eso
 * es el "se cerró y se fue para arriba" que reportó el piloto con 19 campañas por identificar
 * (card jiJyztGD).
 *
 * El orden de las claves va de la más estable a la menos: la línea del plan (`line_key`, que
 * sobrevive incluso a renombrar la línea), la BU destino, y como último recurso acción + nombre.
 * Nunca devuelve vacío: dos filas con la misma `key` de React se pisarían.
 */
export function rowIdentity(item) {
    const payload = (item && item.payload) || {};
    const action = (item || {}).action_type;
    const base = payload.line_key ? `line::${payload.line_key}`
        : payload.business_unit_id ? `bu::${payload.business_unit_id}`
        : `name::${payload.name || (item || {}).target_id || ''}`;
    // UNA línea del plan puede aportar VARIAS filas, y todas comparten `line_key` y `business_unit_id`:
    // su CREATE/UPDATE más un CONFLICT por cada objetivo que choca con una edición manual — el
    // backend emite esos conflictos en loop, uno por métrica a nivel línea y uno por métrica por
    // campaña (`_emit_goal_conflict` en `proposal_service.py`). Sin desempate, esas filas tendrían la
    // MISMA identidad: React las dibujaría con la misma `key` y el acordeón abriría todas a la vez al
    // abrir una. El desempate usa los mismos campos que el `dedup_suffix` del backend, que son los
    // que hacen única a esa fila y salen del payload, no de la PK — así sigue sobreviviendo a una
    // regeneración.
    const id = `${base}::${action}`;
    if (action === 'CONFLICT') {
        return `${id}::${payload.level || ''}:${payload.metric_name || ''}:${payload.campaign_id || ''}`;
    }
    return id;
}

export default rowIdentity;
